import "./PendingChangesPanel.scss";
import { Header } from "../StickyTable";
import { RowType } from "./pendingChangesUtils";
import React from "react";

interface PendingNewRowProps<R> {
  columns: Header[];
  newRow: R;
  pendingRowHeaderRender?: (row: R) => JSX.Element;
}

const PendingNewRow = <R extends RowType>({
  columns,
  newRow,
  pendingRowHeaderRender,
}: PendingNewRowProps<R>): JSX.Element => {
  return (
    <div className="pendingChangesRowContainer pendingNewRowContainer">
      {pendingRowHeaderRender && pendingRowHeaderRender(newRow) && (
        <div className="pendingChangesRowTitle">{pendingRowHeaderRender(newRow)}</div>
      )}
      {columns.map(col => {
        const { label, field, renderer } = col;
        const newVal = newRow[field || ""] || "null";
        return (
          <div key={label}>
            <div className="pendingChangesRow">
              <b className="pendingChangesRowLabel">{label}:</b>
              <div>{renderer ? renderer(newRow) : newVal}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PendingNewRow;
